import React, { type ReactNode } from "react";

type CsMessageTextContentProps = {
  content: string;
  renderInline?: (text: string) => ReactNode;
};

/** 按 \n 分行展示，每行独立成块以便控制段间距 */
export function CsMessageTextContent({ content, renderInline }: CsMessageTextContentProps) {
  const render = renderInline ?? ((text: string) => text);
  const lines = content.split("\n");

  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="cs-msg-paragraph">
          {render(line)}
        </span>
      ))}
    </>
  );
}

export default CsMessageTextContent;
